import {createSelector} from 'reselect';
import {IReduxState} from '../../common/store';
import {IUser} from '../type';

export const getUserId = createSelector(
  (state: IReduxState) => state.auth.user,
  (user: IUser | undefined) => (user ? user.id : undefined)
);
